// libs
import styled from 'styled-components'
import { darken } from 'polished'
// icons
import DragIconOrigin from '@mui/icons-material/DragHandle'
// themes
import colors from 'themes/colors'
// components
import { Scrollbar as ScrollbarOrigin } from 'components/UI'

const DragIcon = styled(DragIconOrigin)`
  width: 24px;
  align-self: unset;
  cursor: grab;
  margin: 0 !important;

  path {
    fill: ${colors.gray280};
  }
`

const Container = styled.div`
  padding: 16px;
`

const Scrollbar = styled(ScrollbarOrigin)`
  height: 360px;
  padding-right: 16px;
`

const Header = styled.div`
  display: flex;
  margin: 12px 48px 16px 0;
  color: ${colors.gray400};

  span {
    flex: 1;
  }

  > :nth-child(4) {
    flex: 0;
    min-width: 90px;
  }

  && {
    > svg {
      top: 20px;
      right: 10px;

      path {
        fill: ${colors.blue500};
      }
    }
  }
`

const Option = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;

  > div {
    flex: 1;
  }

  > :nth-child(4) {
    flex: 0;
    min-width: 90px;
    cursor: pointer;
    border: none;
  }

  svg {
    align-self: end;
    margin-bottom: 12px;
    color: ${colors.blue500};

    &:hover {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }

  span {
    font-size: 14px;
    color: ${colors.gray400};
  }
`

const Value = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 6px;
  font-weight: 500;
  color: ${colors.white};
  height: 44px;
  background: ${({ color }) => color || colors.gray190};
  border: 2px solid transparent;

  &:hover {
    border-color: ${colors.blue500};
  }

  input {
    font-size: 16px;
    border: none;
    outline: none;
    background: ${colors.gray190};
    width: 100%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ::placeholder {
      color: ${colors.black};
    }
  }

  > span {
    display: flex;
  }
`

const AddButton = styled('div')`
  && {
    color: ${colors.blue500};
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    margin-top: 8px;
    user-select: none;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  margin-top: 20px;
`

export { DragIcon, Container, Scrollbar, Header, Option, Value, AddButton, ButtonsContainer }
